import numbro from 'numbro';

export function formatCurrency(value: number, currencyCode: string): string {
    const format: numbro.Format = {
        thousandSeparated: true,
        currencySymbol: currencyCode === "GBP" ? "£" : "€",
        mantissa: 2,
    };

    return numbro(value).formatCurrency(format);
}

export function unformatNumber(value: string): number {
    return numbro.unformat(value);
}
